import './App.css';
import Header from '../src/Component/Header/Header'
import Graph from './Component/Graph/Graph'
import {useState, useEffect} from 'react'
import io from 'socket.io-client'

function App() {
  const [nagmatiData, setNagmatiData]= useState([]);
  useEffect(() => {
    const socket_gss = io.connect('https://gss.wscada.net/');

    socket_gss.on('connect', () => {
      console.log('sending client requests');
      socket_gss.emit('client_request', 'nagmati');
    });


    socket_gss.on('reconnect', () => {
      console.log('resending client requests');;
      socket_gss.emit('client_request', 'nagmati');
    });

    socket_gss.on('disconnect', err => {
      console.log('socket disconnected', err);
    });

    socket_gss.on('nagmati', res => {
      setNagmatiData(res)
    });


  }, [])
  
  return (
    <>
    <Header/>
    <div className="graphImg">
    <Graph data={nagmatiData}/>
    </div>
    </>
  );
}

export default App;
